import 'react';
import 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'reakit/Overlay';
import '../Overlay/OverlayContainer.js';
import '../Overlay/styled.js';
import '../Overlay/OverlayHide.js';
import '../Overlay/OverlayShow.js';
import '../Overlay/OverlayToggle.js';
import '../chunk-7b491460.js';
import Overlay from '../Overlay/index.js';

var ModalHide = styled(Overlay.Hide).withConfig({
  displayName: "styled__ModalHide",
  componentId: "sc-13yjzse-0"
})(["", ";"], theme('fannypack.Modal.Hide.base'));
var ModalShow = styled(Overlay.Show).withConfig({
  displayName: "styled__ModalShow",
  componentId: "sc-13yjzse-1"
})(["", ";"], theme('fannypack.Modal.Show.base'));
var Modal = styled(Overlay).withConfig({
  displayName: "styled__Modal",
  componentId: "sc-13yjzse-2"
})(["padding:0 1rem;max-width:600px;width:100%;", ";"], theme('fannypack.Modal.base'));

export default Modal;
export { Modal, ModalHide, ModalShow };
